import {
  lime10,
  lime40,
  lime60,
  lime80,
  lime100,
  lime120,
  orange10,
  orange40,
  orange60,
  orange80,
  orange100,
  orange120,
  pink10,
  pink40,
  pink60,
  pink80,
  pink100,
  pink120,
  purple10,
  purple40,
  purple60,
  purple80,
  purple100,
  purple120,
  red10,
  red40,
  red60,
  red80,
  red100,
  red120,
} from "../../COREDesignSystem/Content/COREColour";

export type NEMState = "NSW" | "QLD" | "SA" | "VIC" | "TAS";

export type NEMStateColourShade = 10 | 40 | 60 | 80 | 100 | 120;

export const NEM_STATE_COLOURS: Record<
  NEMState,
  Record<NEMStateColourShade, string>
> = {
  NSW: { 10: red10, 40: red40, 60: red60, 80: red80, 100: red100, 120: red120 },
  QLD: {
    10: orange10,
    40: orange40,
    60: orange60,
    80: orange80,
    100: orange100,
    120: orange120,
  },
  SA: {
    10: pink10,
    40: pink40,
    60: pink60,
    80: pink80,
    100: pink100,
    120: pink120,
  },
  VIC: {
    10: lime10,
    40: lime40,
    60: lime60,
    80: lime80,
    100: lime100,
    120: lime120,
  },
  TAS: {
    10: purple10,
    40: purple40,
    60: purple60,
    80: purple80,
    100: purple100,
    120: purple120,
  },
};

export const NEM_STATE_COLOURS_100: Record<NEMState, string> = {
  NSW: NEM_STATE_COLOURS.NSW[100],
  QLD: NEM_STATE_COLOURS.QLD[100],
  SA: NEM_STATE_COLOURS.SA[100],
  VIC: NEM_STATE_COLOURS.VIC[100],
  TAS: NEM_STATE_COLOURS.TAS[100],
};
